import { Component, inject, TemplateRef } from '@angular/core';
import { Toast, ToastService } from '../../services/toast.service';

@Component({
    selector: 'isophi-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.scss'],
    standalone: false
})
export class ToastsComponent {
  public readonly toastService = inject(ToastService);

  isTemplate(toast: Toast) { return toast.textOrTpl instanceof TemplateRef; }
}
